/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import {
  Row, Col, UncontrolledCollapse, Table,
} from 'reactstrap';
import { Intl } from 'components';
import './style.css';
import './css/style.css';
import './css/payment.css';

export default React.memo(
  ( {
    getTableProps,
    headerGroups,
    page,
    prepareRow,
    canNextPage,
    nextPage,
    filters,
    customToggleFilters,
    setFilter,
    isLoading,
    hiddenIsLoading,
    customFilters,
    titleContent,
    rightContent,
    setGlobalFilter,
    globalFilter,
    setMultipleFilters,
    tableClassName,
    containerClassName,
    minRows,
    columns,
    fullHeader,
    headerWidth,
    columnWidth,
    minHeight = false,
    getRowProps = () => ( {} ),
    tableName = '',
    values = {},
  } ) => {
    const [deviceSize, setDeviceSize] = React.useState(
      Math.round( window.devicePixelRatio * 100 ),
    );
    const [tableHeight, setTableHeight] = React.useState( 0 );
    const numCells = columns.length ? columns.length : 1;
    const innerDivRef = useRef( null );

    const getSizes = useCallback(
      () => {
        const windowPer = Math.round(window.devicePixelRatio * 100);
        setDeviceSize(Math.round(window.devicePixelRatio * 100));
        if (windowPer == 67 || windowPer == 50) {
          setTableHeight(minRows * 35 - 3 - 10);
        } else if (windowPer == 100) {
          setTableHeight(minRows * 35 - 3);
        } else if (windowPer == 125) {
          setTableHeight(minRows * 35 - 3 - 42);
        } else if (windowPer == 150 || windowPer == 175) {
          setTableHeight(minRows * 35 - 3 - 57);
        } else if (windowPer == 200 || windowPer == 250) {
          setTableHeight(minRows * 35 - 3 - 82);
        } else {
          setTableHeight(minRows * 35 - 3);
        }
      },
      [setTableHeight,minRows],
    ) 

    useEffect( () => {
      getSizes();
      window.addEventListener( 'resize', getSizes, false );
    }, [getSizes] );

    useEffect( () => {
      const innerDiv = innerDivRef.current;
      const limit = 20;
      let timer = null;

      const detectScroll = () => {
        clearTimeout( timer );

        timer = setTimeout( () => {
          const myTable = document.getElementById( 'myTableBody' );

          // const offsetHeight = minRows * 35 - 3;
          const offsetHeight = tableHeight;

          if (
            myTable.scrollHeight - myTable.scrollTop >= offsetHeight - 1
            && myTable.scrollHeight - myTable.scrollTop <= offsetHeight + 1
            && !isLoading
          ) {
            nextPage();
          }
        }, 200 );
      };

      if ( window ) {
        if ( canNextPage ) {
          clearTimeout( timer );
          innerDiv.addEventListener( 'scroll', detectScroll );
          detectScroll();
        } else {
          clearTimeout( timer );
          innerDiv.removeEventListener( 'scroll', detectScroll );
        }
      }
      return () => {
        if ( window ) {
          innerDiv.removeEventListener( 'scroll', detectScroll );
        }
      };
    }, [canNextPage, nextPage, isLoading, minRows, tableHeight] );

    const pageLength = page.length;
    const minRowsToFillList = [];
    for ( let i = 0; i < minRows - pageLength; i += 1 ) {
      minRowsToFillList.push( i );
    }
    const minRowsCellToFillList = [];
    for ( let i = 0; i < numCells; i += 1 ) {
      minRowsCellToFillList.push( i );
    }

    return (
      <div
        className={classnames( containerClassName, {
          'app-component-loading': isLoading && !hiddenIsLoading,
        } )}
      >
        <Row className="align-items-center">
          {titleContent || customFilters ? (
            <Col
              xs={12}
              md={fullHeader ? 12 : 7}
              lg={fullHeader ? 12 : 8}
              className="mb-2 mb-md-0"
            >
              {titleContent}
              {customFilters
                ? customFilters( {
                  filters,
                  setFilter,
                  globalFilter,
                  setGlobalFilter,
                  setMultipleFilters,
                } )
                : null}
            </Col>
          ) : null}
          <Col
            xs={12}
            md={titleContent || customFilters ? 5 : 12}
            lg={titleContent || customFilters ? 4 : 12}
          >
            <div className="w-100 d-flex flex-wrap align-items-center justify-content-end">
              {!!rightContent && (
                <div className="ml-0 ml-sm-2 mt-2 mt-md-0 p-0 d-none d-md-block">
                  {rightContent}
                </div>
              )}
              {!!rightContent && (
                <div className="ml-0 ml-sm-2 mt-2 mt-md-0 p-0 d-md-none col-12 text-right">
                  {rightContent}
                </div>
              )}
            </div>
          </Col>
        </Row>

        {customToggleFilters ? (
          <UncontrolledCollapse toggler="#tableToggler">
            <hr className="mt-4 mb-3 border-top" />
            {customToggleFilters( { filters, setFilter, setMultipleFilters } )}
          </UncontrolledCollapse>
        ) : null}
        <div className="py-2">
          <div className="table-scroll-wrap">
            <div
              className="table-scroll-container"
              style={{
                // height: `${minRows * 35 - 3}px`,
                height: `${tableHeight}px`,
              }}
            >
              <div
                className={classnames( 'table-responsive', {
                  'no-scroll': !page.length,
                } )}
              >
                <Table
                  className={classnames(
                    'align-items-center table-flush',
                    tableClassName,
                  )}
                  {...getTableProps()}
                >
                  <thead
                    className="thead-light paddingRight"
                    // style={{ paddingRight: minRows > 1 ? '5px' : '0px' }}
                    style={{width:"calc(100% - 5px)"}}
                  >
                    {headerGroups.map( ( headerGroup ) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map( ( column, i ) => {
                          const headerW = headerWidth && headerWidth.length
                            ? headerWidth[i]
                            : 'col';
                          return (
                            <th
                              className={`cursor-pointer ${headerW}`}
                              {...( !column.disableSorting
                                ? column.getHeaderProps( {
                                  ...column.getSortByToggleProps(),
                                  ...{
                                    style: {
                                      overflow: 'hidden',
                                      ...column.style,
                                    },
                                  },
                                } )
                                : column.getHeaderProps( {} ) )}
                            >
                              {column.render( 'Header' )
                              && column.disableTranslate !== true ? (
                                <Intl
                                  id={column.render( 'Header' )}
                                  values={values}
                                />
                                ) : (
                                  column.render( 'Header' )
                                )}
                            </th>
                          );
                        } )}
                      </tr>
                    ) )}
                  </thead>
                  <tbody
                    className={`list myCustomScrollbar ${
                      tableName == '' ? 'nopadding' : 'paymentpadding'
                    } marginLeft-5`}
                    id="myTableBody"
                    style={{
                      display: 'block',
                      // height: `${minRows * 35 - 3}px`,
                      height: `${tableHeight}px`,
                      overflowY: minRows > 1 ? 'overlay' : 'hidden',
                      overflowX: 'auto',
                      scrollbarGutter: 'stable both-edges',
                      // marginLeft: '-5px!important'
                    }}
                    ref={innerDivRef}
                  >
                    {pageLength ? (
                      page.map(
                        ( row ) => prepareRow( row ) || (
                        <tr
                          className="d-flex align-items-center justify-content-center"
                          {...row.getRowProps( getRowProps( row ) )}
                        >
                          {row.cells.map( ( cell, i ) => {
                            const cellWidth = headerWidth && headerWidth.length
                              ? headerWidth[i]
                              : 'col';
                            return (
                              <td
                                className={`${cellWidth} ${
                                  minHeight ? 'minHeight' : ''
                                }`}
                                {...cell.getCellProps( {
                                  style: {
                                    verticalAlign: 'middle',
                                    ...cell.column.style,
                                  },
                                } )}
                              >
                                {cell.render( 'Cell' )}
                              </td>
                            );
                          } )}
                        </tr>
                        ),
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={100}
                          style={{
                            width:
                              document.getElementById( 'myTableBody' )
                              && document.getElementById( 'myTableBody' ).clientWidth
                                ? document.getElementById( 'myTableBody' )
                                  .clientWidth+200
                                : '100%',
                          }}
                          className="text-center"
                        >
                          <Intl id="noTableData" />
                        </td>
                      </tr>
                    )}
                    {minRowsToFillList.map( ( r ) => (
                      <tr className="d-flex" key={r}>
                        {minRowsCellToFillList.map( ( cell, i ) => {
                          const cellWidth = headerWidth && headerWidth.length
                            ? headerWidth[i]
                            : 'col';
                          return (
                            <td key={cell} className={cellWidth}>
                              &nbsp;
                            </td>
                          );
                        } )}
                      </tr>
                    ) )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
